import RestResource from "@/api/rest/rest-resource";
import {ORGANIZATION_SERVER} from "@/api";
import {athubAxios} from "@/util";

const roleRelation = new RestResource({server: ORGANIZATION_SERVER, resource: 'roleRelation'});

roleRelation.queryTreeInfo = (pId) => {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/roleRelation/pId/${pId}`).then(res => {
            if (res.status == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

roleRelation.batchAdd = (roleId, roleIdList) => {
    let url = `${ORGANIZATION_SERVER}/roleRelation/bind/roleId/${roleId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, roleIdList).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

roleRelation.delete = (pId, cId) => {
    let url = `${ORGANIZATION_SERVER}/roleRelation/unBind/pId/${pId}/cId/${cId}`;
    return new Promise((resolve, reject) => {
        athubAxios.delete(url).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

export default roleRelation;

